import memoizeOne from 'memoize-one';
import { ff } from '@atlassian/jira-feature-flagging';
import { devSummaryColumnWidth } from '../field-types/dev-summary/column-widths';
import { goalsColumnWidth } from '../field-types/goals/column-widths';
import { groupColumnWidth } from '../field-types/group/column-widths';
import { projectColumnWidth } from '../field-types/project/column-widths';
import { radioSelectColumnWidth } from '../field-types/radio-select/column-width';
import { resolutionColumnWidth } from '../field-types/resolution/column-widths';
import { teamColumnWidth } from '../field-types/team/column-widths';
import { versionColumnWidth } from '../field-types/version/column-widths';

// Used in utils to get the default column widths
export const getColumnWidths = memoizeOne(() => ({
	...versionColumnWidth,
	...devSummaryColumnWidth,
	...teamColumnWidth,
	...goalsColumnWidth,
	...(ff('jira.list.field-support-part1')
		? {
				...resolutionColumnWidth,
				...groupColumnWidth,
				...radioSelectColumnWidth,
				...projectColumnWidth,
			}
		: {}),
}));
